import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";

import { LoginForm } from "@/components/login-form";
import { useAuth } from "@/hooks/use-auth";
import { t } from "@/i18n/pl";

export function LoginPage() {
  const { user, isLoading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Already signed in: bounce to wherever they were originally headed.
  const from = (location.state as { from?: string } | null)?.from ?? "/";
  if (!isLoading && user) return <Navigate to={from} replace />;

  return (
    // Navy backdrop: the ZM Skiba logo assets are white+gold and only read on
    // dark surfaces, mirroring the header/footer treatment on zmskiba.pl.
    <div className="bg-sidebar flex min-h-svh flex-col items-center justify-center gap-8 p-6 md:p-10">
      <div className="animate-in fade-in slide-in-from-bottom-3 flex flex-col items-center gap-3 duration-700">
        <img src="/logo.png" alt="ZM SKIBA S.A." className="h-16 w-auto" />
        <p className="text-sidebar-foreground text-xl font-bold tracking-tight">
          {t.appName}
        </p>
      </div>
      <div className="animate-in fade-in slide-in-from-bottom-2 w-full max-w-sm delay-150 duration-700 fill-mode-both">
        <LoginForm onSuccess={() => void navigate(from, { replace: true })} />
      </div>
      <p className="text-sidebar-foreground/60 animate-in fade-in text-xs delay-300 duration-700 fill-mode-both">
        {t.tagline} · {t.auth.inviteOnly} ·{" "}
        <Link to="/prywatnosc" className="underline underline-offset-2">
          {t.footer.privacy}
        </Link>
      </p>
    </div>
  );
}
